import type { OrderDetailBlGroup } from '@metycle/shared';
import type { CoverageBl } from './use-coverage-state';

// Client-side quantity-ratio prefill for the create picker, exact-sum to the
// cent: every BL but the last rounds down, the last absorbs the remainder — so
// the pill starts green and matches the server's own split. Equal split when no
// BL carries a loaded quantity. Prefill only; the operator can overwrite.
export function prefillByQuantity(rows: readonly CoverageBl[], total: number): Map<string, string> {
  const out = new Map<string, string>();
  if (rows.length === 0 || total <= 0) return out;
  const totalCents = Math.round(total * 100);
  const qtys = rows.map((row) => {
    const q = row.quantityMt === null ? 0 : Number.parseFloat(row.quantityMt);
    return Number.isFinite(q) && q > 0 ? q : 0;
  });
  const totalQty = qtys.reduce((sum, q) => sum + q, 0);
  let assigned = 0;
  rows.forEach((row, i) => {
    let cents: number;
    if (i === rows.length - 1) {
      cents = totalCents - assigned;
    } else if (totalQty > 0) {
      cents = Math.floor((totalCents * (qtys[i] ?? 0)) / totalQty);
    } else {
      cents = Math.floor(totalCents / rows.length);
    }
    assigned += cents;
    out.set(row.blOrderId, (cents / 100).toFixed(2));
  });
  return out;
}

// The order's live BLs as picker rows — no advance exists yet at create, so
// every consumed floor is zero.
export function coverageRowsFromBls(orderBls: readonly OrderDetailBlGroup[]): CoverageBl[] {
  return orderBls.map((bl) => ({
    blOrderId: bl.id,
    name: bl.name,
    quantityMt: bl.loadedMt,
    appliedFloor: 0,
  }));
}
